import {
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
} from './records.enum';

export const SEARCH = 'SEARCH';
export const REPORT = 'REPORT';
export const FRONTLINE_COACHES = 'frontlineCoaches';
export const COACHES_ONLY = 'coachesOnly';
export const ALL = 'all';
export const NO_CLIENTS = 'noClients';
export const ONE_TWO_NEW_QUALIFIED_CLIENT = 'one_two_newQualifiedClient';
export const THREE_FOUR_NEW_QUALIFIED_CLIENT = 'three_four_newQualifiedClient';
export const FIVE_SIX_NEW_QUALIFIED_CLIENT = 'five_six_newQualifiedClient';
export const SEVEN_NINE_NEW_QUALIFIED_CLIENT = 'seven_nine_newQualifiedClient';
export const TEN_PLUS_NEW_QUALIFIED_CLIENT = 'ten_plus_newQualifiedClient';
export const FILTERS = {
  coachesOnly: {
    key: COACHES_ONLY,
    label: 'Coaches Only',
    params: {filterBy: COACHES_ONLY},
  },
  frontlineCoaches: {
    key: FRONTLINE_COACHES,
    label: 'Frontline Coaches & Clients Only',
    params: {filterBy: FRONTLINE_COACHES},
  },
  all: {
    key: ALL,
    label: 'All',
    // params: {filterBy: 'oeCount', filterByValue: 0},
  },
  noClients: {
    key: NO_CLIENTS,
    label: 'No Clients',
    params: {filterBy: 'oeCount', filterByValue: 0},
  },
  one_two_newQualifiedClient: {
    key: ONE_TWO_NEW_QUALIFIED_CLIENT,
    label: '1-2 New Qualified Client',
    params: {filterBy: 'oeCount', filterByValue: '1_2'},
  },
  three_four_newQualifiedClient: {
    key: THREE_FOUR_NEW_QUALIFIED_CLIENT,
    label: '3-4 New Qualified Clients',
    params: {filterBy: 'oeCount', filterByValue: '3_4'},
  },
  five_six_newQualifiedClient: {
    key: FIVE_SIX_NEW_QUALIFIED_CLIENT,
    label: '5-6 New Qualified Clients',
    params: {filterBy: 'oeCount', filterByValue: '5_6'},
  },
  seven_nine_newQualifiedClient: {
    key: SEVEN_NINE_NEW_QUALIFIED_CLIENT,
    label: '7-9 New Qualified Clients',
    params: {filterBy: 'oeCount', filterByValue: '7_9'},
  },
  ten_plus_newQualifiedClient: {
    key: TEN_PLUS_NEW_QUALIFIED_CLIENT,
    label: '10+ New Qualified Clients',
    params: {filterBy: 'oeCount', filterByValue: '10_plus'},
  },
};

export const RECORDS_FILTERS = {
  [SEARCH]: {
    default: '',
    items: [FILTERS.coachesOnly, FILTERS.frontlineCoaches],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO]: {
    default: ONE_TWO_NEW_QUALIFIED_CLIENT,
    items: [
      FILTERS.all,
      FILTERS.noClients,
      FILTERS.one_two_newQualifiedClient,
      FILTERS.three_four_newQualifiedClient,
      FILTERS.five_six_newQualifiedClient,
      FILTERS.seven_nine_newQualifiedClient,
      FILTERS.ten_plus_newQualifiedClient,
    ],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR]: {
    default: THREE_FOUR_NEW_QUALIFIED_CLIENT,
    items: [
      FILTERS.all,
      FILTERS.noClients,
      FILTERS.one_two_newQualifiedClient,
      FILTERS.three_four_newQualifiedClient,
      FILTERS.five_six_newQualifiedClient,
      FILTERS.seven_nine_newQualifiedClient,
      FILTERS.ten_plus_newQualifiedClient,
    ],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX]: {
    default: FIVE_SIX_NEW_QUALIFIED_CLIENT,
    items: [
      FILTERS.all,
      FILTERS.noClients,
      FILTERS.one_two_newQualifiedClient,
      FILTERS.three_four_newQualifiedClient,
      FILTERS.five_six_newQualifiedClient,
      FILTERS.seven_nine_newQualifiedClient,
      FILTERS.ten_plus_newQualifiedClient,
    ],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE]: {
    default: SEVEN_NINE_NEW_QUALIFIED_CLIENT,
    items: [
      FILTERS.all,
      FILTERS.noClients,
      FILTERS.one_two_newQualifiedClient,
      FILTERS.three_four_newQualifiedClient,
      FILTERS.five_six_newQualifiedClient,
      FILTERS.seven_nine_newQualifiedClient,
      FILTERS.ten_plus_newQualifiedClient,
    ],
  },
};
